/**
 * DOM Ready alternative.
 * Works in/with async scripts!
 */
/* eslint-disable */

export const interactive = () => {
  return new Promise((resolve) => {
    if (document.readyState !== 'loading') {
      resolve();
    }
    else {
      document.addEventListener('readystatechange', () => {
        if (document.readyState === 'interactive') {
          resolve();
        }
      });
    }
  });
};
